/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_StampsInputs */

const en_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Enough Stamps`)
};

const ar_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`طوابع غير كافية`)
};

const de_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht genügend Stempel`)
};

const es_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sellos insuficientes`)
};

const fr_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timbres insuffisants`)
};

const it_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timbri insufficienti`)
};

const ja_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンプが不足しています`)
};

const ko_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스탬프 부족`)
};

const pt_br_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selos insuficientes`)
};

const ru_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недостаточно штампов`)
};

const th_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แสตมป์ไม่เพียงพอ`)
};

const tr_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yetersiz pul`)
};

const zh_cn_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花不足`)
};

const zh_tw_dialog_not_enough_stamps = /** @type {(inputs: Dialog_Not_Enough_StampsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花不足`)
};

/**
* | output |
* | --- |
* | "Not Enough Stamps" |
*
* @param {Dialog_Not_Enough_StampsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_stamps = /** @type {((inputs?: Dialog_Not_Enough_StampsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_StampsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_stamps(inputs)
	if (locale === "ar") return ar_dialog_not_enough_stamps(inputs)
	if (locale === "de") return de_dialog_not_enough_stamps(inputs)
	if (locale === "es") return es_dialog_not_enough_stamps(inputs)
	if (locale === "fr") return fr_dialog_not_enough_stamps(inputs)
	if (locale === "it") return it_dialog_not_enough_stamps(inputs)
	if (locale === "ja") return ja_dialog_not_enough_stamps(inputs)
	if (locale === "ko") return ko_dialog_not_enough_stamps(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_stamps(inputs)
	if (locale === "ru") return ru_dialog_not_enough_stamps(inputs)
	if (locale === "th") return th_dialog_not_enough_stamps(inputs)
	if (locale === "tr") return tr_dialog_not_enough_stamps(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_stamps(inputs)
	return zh_tw_dialog_not_enough_stamps(inputs)
});